import AOCContainer from '../pages/auth/aocContainer';
import ApplicantDetail from '../pages/auth/applicantDetail';
import Applicants from '../pages/auth/applicant';
import Home from '../pages/auth/home';
import JobApply from '../pages/unauth/jobApply';
import JobContainer from '../pages/unauth/jobContainer'
import JobDetail from '../pages/unauth/jobDetail';
import JobList from '../pages/unauth/jobList';
import JobForm from '../pages/auth/jobForm';
import OCContainer from '../pages/unauth/ocContainer';
import OCLogin from '../pages/unauth/ocLogin';
import OCRegister from '../pages/unauth/ocRegister';
import Setting from '../pages/auth/setting';
import UserProfile from '../pages/auth/userProfile';

export const routes = [
    {
        path: '/job',
        component: JobContainer,
        routes: [
            {
                path: '/job/:slug/detail',
                component: JobDetail
            },
            {
                path: '/job/:slug/apply',
                component: JobApply
            },
            {
                path: '/job/open',
                component: JobList
            }
        ]
    },
    {
        path: '/oc',
        component: OCContainer,
        routes: [
            {
                path: '/oc/login',
                component: OCLogin
            },
            {
                path: '/oc/register',
                component: OCRegister
            }
        ]
    },
    {
        path: '/aoc',
        component: AOCContainer,
        routes: [
            {
                path: '/aoc/home',
                component: Home,
                icon: "icon-equalizer",
                name: "Dashboard"
            },
            {
                path: '/aoc/jobs',
                component: JobList,
                icon: "icon-briefcase",
                name: "Jobs"
            },
            {
                path: '/aoc/job/:slug/edit',
                component: JobForm
            },
            {
                path: '/aoc/job/add',
                component: JobForm
            },
            {
                path: '/aoc/applicants',
                component: Applicants,
                icon: "icon-docs",
                name: "Applicants"
            },
            // {
            //     path: '/aoc/applicants',
            //     component: Home,
            //     icon: "icon-docs",
            //     name: "Applicants"
            // },
            {
                path: '/aoc/applicant/:id/detail',
                component: ApplicantDetail
            },
            // {
            //     path: '/aoc/users',
            //     component: Applicants,
            //     icon: "icon-people",
            //     name: "User Management"
            // },
            {
                path: '/aoc/user-profile',
                component: UserProfile,
                icon: "icon-user",
                name: "User Profile"
            },
            {
                path: '/aoc/setting',
                component: Setting,
                icon: "icon-wrench",
                name: "Setting"
            }
        ]
    }
]

export const nav = routes[2].routes;

export const newForm = 'https://devstack.survey.fm/pre-recruitment-form';


// WEBPACK FOOTER //
// ./src/config/routes.js